/**
 * Chemin de la page de connexion admin « discrète ».
 *
 * Rappel : l'URL cachée relève de l'obscurité, pas de la sécurité. La vraie
 * barrière reste le mot de passe + le ROLE_ADMIN exigé côté API. Pour changer
 * l'URL, il suffit de modifier cette constante (route et page la partagent).
 */
export const ADMIN_LOGIN_PATH = '/jl-admin'
